// City and province lists behind the CRM's address pickers (the customer form and MIS's shipping address).
//
// One JSON file per country - src/data/cities/<ISO>.json, built by scripts/buildCityData.cjs from GeoNames
// (https://www.geonames.org, CC BY 4.0) - and each is its own webpack chunk: none of it is in the main
// bundle, a country's list is fetched the first time somebody picks that country, then kept.
//
// A list is an array of options { city, province, fc, fp, fb }, most populous city first. `province` is ''
// for a country that has none (Singapore). `fc` / `fp` / `fb` are the city, the province and both together
// folded for matching (no case, no accents), so typing "izmir" finds İzmir.
//
// If a chunk cannot be fetched (offline, a half-deployed build) the short list countryData.js has always
// carried is used instead, so the picker is never empty - and a city typed by hand is always allowed.
import { ISO_MAP } from './countryData';

/** Lower-case, accent-free, trimmed - the form two spellings are compared in. */
export const fold = (s) => String(s == null ? '' : s).normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

export const cityOption = (city, province = '') => {
  const fc = fold(city);
  const fp = fold(province);
  return { city, province, fc, fp, fb: `${fc} ${fp}`.trim() };
};

/** The short built-in list of a country: what the picker shows until (or without) the full one. */
export const quickCities = (code) => ((ISO_MAP[code] && ISO_MAP[code].cities) || []).map((name) => cityOption(name));

const lists = new Map();   // ISO -> Promise<option[] | null>

/** A country's cities with their provinces. Never rejects: a list that cannot be loaded is the short one. */
export function loadCities(code) {
  if (!code) return Promise.resolve([]);
  if (!lists.has(code)) {
    lists.set(code,
      import(/* webpackChunkName: "city-[request]" */ `../../../data/cities/${code}.json`)
        .then((mod) => {
          const data = mod.default || mod;
          return data.c.map(([city, index]) => cityOption(city, index >= 0 ? data.p[index] : ''));
        })
        .catch(() => { lists.delete(code); return null; }));   // not cached, so the next pick tries again
  }
  return lists.get(code).then((list) => list || quickCities(code));
}
